export default {
  loading: "拼命加載中",
  totalData: "條數據",
  totalPrefix: "共計",
  download: "下載",
  downloadDetails: "下載數據明細",
  noData: "暫無數據",
  columns: {
    direction: "交易方向",
    totalCount: "交易次數",
    currency: "幣種",
    totalQuantity: "交易總數量",
  },
  directions: {
    buy: "買入",
    sell: "賣出",
    unknown: "未知",
  },
};
